"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import ReactPlayer from "react-player";
interface VideoPlayerModalProps {
  videoUrl: string;
  title?: string;
  children: React.ReactNode;
}
const VideoPlayerModal = t0 => {
  const $ = _c(11);
  const {
    videoUrl,
    title,
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <button onClick={t1}>{children}</button>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLoading || $[4] !== isOpen || $[5] !== title || $[6] !== videoUrl) {
    t3 = isOpen && videoUrl && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={e => {
      if (e.target === e.currentTarget) {
        setIsOpen(false);
      }
    }}><div className="relative w-full max-w-4xl"><button onClick={() => setIsOpen(false)} className="absolute -top-12 right-0 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white hover:bg-white/30" aria-label="Close video">✕</button><div className="relative aspect-video overflow-hidden rounded-lg bg-black">{isLoading && <div className="absolute inset-0 flex items-center justify-center bg-black"><div className="h-12 w-12 animate-spin rounded-full border-4 border-white/30 border-t-white" /></div>}<ReactPlayer src={videoUrl} width="100%" height="100%" controls={true} playing={true} onReady={() => setIsLoading(false)} /></div>{title && <div className="mt-4 rounded-lg bg-white/10 p-4 backdrop-blur-sm"><p className="text-lg font-medium text-white">{title}</p></div>}</div></div>;
    $[3] = isLoading;
    $[4] = isOpen;
    $[5] = title;
    $[6] = videoUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default VideoPlayerModal;